<template>
  <div class="OrderTable" v-loading="loading">
    <!-- <div class="top_bar">
      <div class="case" style="text-align: right">
        <div class="case-title">
          <img class="case-title_icon" src="@/assets/images/icon_lb@2x.png" alt />
          <div class="case-title_max">
            订单列表<span style="color: #ff5757; margin-left: 5px">({{ this.pages.total }})</span>
          </div>
        </div>
      </div>
      <el-button size="small" type="success" icon="el-icon-download" @click="submitExcel">导出Excel</el-button>
    </div> -->
    <div class="button_top">
      <div class="faultBtn">
        <div
          :class="auditStatus === '00' ? 'active' : 'none'"
          @click="btnClick('00')"
        >
          未上架({{ applyNumber.unPutaway || 0 }})
        </div>
        <div
          :class="auditStatus === '03' ? 'active' : 'none'"
          @click="btnClick('03')"
        >
          在售中({{ applyNumber.selling || 0 }})
        </div>
        <div
          :class="auditStatus === '05' ? 'active' : 'none'"
          @click="btnClick('05')"
        >
          已售完({{ applyNumber.sellOut || 0 }})
        </div>
        <div
          :class="auditStatus === '10' ? 'active' : 'none'"
          @click="btnClick('10')"
        >
          已到期({{ applyNumber.overdue || 0 }})
        </div>
      </div>
    </div>
    <div class="isFilter">
      <div class="filterLeft">
        <el-checkbox v-model="isFilterTime">筛选有效期不足3天商品</el-checkbox>
        <el-checkbox style="margin-left: 20px" v-model="isFilterStock"
          >筛选数量不足10个商品</el-checkbox
        >
      </div>
      <div>
        <el-button
          type="primary"
          size="small"
          @click="outexport"
          style="background: rgb(245 154 35); border: 1px solid rgb(245 154 35)"
          >导入商品</el-button
        >
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="addProduct"
          >添加商品</el-button
        >
      </div>
      <!-- 导入订单退单 -->
      <el-dialog
        class="add-dialog"
        title="导入商品"
        :visible.sync="importVisible"
        :close-on-click-modal="false"
        width="510px"
        @closed="exportinDialogClosed"
      >
        <div class="step">
          <div class="step-title">
            <span>说明：下载模板填写商品信息后，将表格上传即可导入商品。</span>
          </div>
          <div class="step-content">
            <el-button
              type="success"
              icon="el-icon-download"
              size="medium"
              @click="download"
              >下载数据模板</el-button
            >
          </div>
          <el-form
            ref="importForm"
            :model="importForm"
            :rules="importRules"
            label-width="80px"
          >
            <el-form-item label="表格上传" prop="fileName" class="fileName">
              <el-input
                v-model="importForm.fileName"
                @clear="fileClear"
                :disabled="true"
                size="medium"
                clearable
              >
              </el-input>
              <div style="float: right; position: relative">
                <el-button size="medium" type="warning" icon="el-icon-upload2"
                  >上传表格</el-button
                >
                <input
                  accept=".xls, .xlsx"
                  ref="fileUpload"
                  @change="onUploadList"
                  type="file"
                  style="
                    opacity: 0;
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    cursor: pointer;
                  "
                />
              </div>
              <div style="color: #ff687b">
                仅支持.xls及.xlsx格式,单次上传大小不超过5M
              </div>
            </el-form-item>
          </el-form>
          <div class="step2-content"></div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="importVisible = false">取消</el-button>
          <el-button type="primary" @click.native="uploadFile">确定</el-button>
        </span>
      </el-dialog>
    </div>
    <div v-if="this.pages.total > 0">
      <div
        v-for="(item, index) in orderTableList"
        :key="index"
        class="order_list"
      >
        <div class="line_top"></div>
        <div class="table_title">
          <div class="left">
            <div class="left-top">
              <div>
                <span class="first-text">{{ index + 1 }}</span>
                <!-- <span class="solo2" v-if="item.expressChannel == '01'">繁星物流</span>
                <span class="solo2" style="background: #84c0ff" v-if="item.expressChannel == '02'">线下物流</span> -->
                <span style="font-weight: 600">商品编码：</span>
                <!-- productCode -->
                <span :id="'productCode' + index">{{ item.productCode }}</span>
                <span class="copy" @click="copy('productCode' + index)"
                  >复制</span
                >
              </div>
              <!-- 商品名称 -->
              <div>
                <span style="font-weight: 600">商品名称：</span>
                <span>{{
                  item.productName == "--" ? item.productName : item.productName
                }}</span>
              </div>
              <!-- 以旧换新： -->
              <div>
                <span style="font-weight: 600">以旧换新补贴：</span>
                <span>{{ item.subsidyPrice }}</span>
              </div>
              <!-- 最近上架时间 -->
              <div>
                <span style="font-weight: 600">最近上架时间：</span>
                <span>{{ item.putawayTimeLast }}</span>
              </div>
            </div>
            <div class="identification">
              <span
                class="rightTrue"
                v-if="
                  (item.state == '00' || item.state == '03') &&
                  item.isStockOverdue == true
                "
                >即将到期</span
              >
              <span
                class="rightTrue"
                v-if="
                  (item.state == '00' || item.state == '03') &&
                  item.isStockInsufficient == true
                "
                >库存不足</span
              >
            </div>
          </div>

          <div class="right">
            <div v-if="item.isEnablePay == true">
              <span class="online-payment">线上支付</span>
            </div>
            <div
              v-if="
                item.state != '10' &&
                item.state != '20' &&
                item.state != '30' &&
                item.isEnablePay == true
              "
              style="display: flex; align-items: center"
            >
              <span v-if="item.userIsCollect == true" style="color: #80c269"
                >已到账门店，已付款给用户</span
              >
              <span v-else style="color: #ff687b"
                >已到账门店，未付款给用户</span
              >
            </div>
            <div
              v-if="item.state == '30' && item.isEnablePay == true"
              style="display: flex; align-items: center"
            >
              <span
                v-if="item.returnedChannel == 'Store'"
                style="color: #80c269; margin-right: 20px"
                >门店退款</span
              >
              <span v-else style="color: #ff687b; margin-right: 20px"
                >拒收退回</span
              >
              <span v-if="item.userIsCollect == true" style="color: #80c269"
                >顾客收款后退单</span
              >
              <span v-else style="color: #ff687b">顾客未收款退单</span>
            </div>
          </div>
        </div>

        <div class="table_list">
          <el-table
            :data="[item]"
            border
            style="width: 100%"
            id="excelOrder"
            :header-cell-style="{ background: 'white' }"
          >
            <el-table-column
              prop="productId"
              label="商品ID"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="typeName"
              label="分类"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cost"
              label="商品成本（元）"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="sellPrice"
              label="商品售价（元）"
              align="center"
            ></el-table-column>
            <el-table-column prop="subsidyType" label="补贴类型" align="center">
              <template slot-scope="{ row }">
                <span>{{
                  row.subsidyType == "00" ? "厂家补贴" : "加价补贴"
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="subsidyPrice"
              label="补贴金额（元）"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="productTotalNum"
              label="换新商品数量"
              align="center"
            >
              <template slot-scope="{ row }">
                <span>{{
                  row.productTotalNum == "--" ? 0 : row.productTotalNum
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="stock" label="剩余商品数量" align="center">
              <template slot-scope="{ row }">
                <span>{{ row.stock == "--" ? 0 : row.stock }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="createStaffPcName"
              label="添加人"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="createTime"
              label="添加时间"
              align="center"
            ></el-table-column>
            <el-table-column prop="periodStart" label="有效期" align="center">
              <template slot-scope="{ row }">
                <span>{{ row.periodStart }}-{{ row.periodEnd }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="sellNum" label="换新售出商品" align="center">
              <template slot-scope="{ row }">
                <span
                  v-if="row.sellNum && row.sellNum != '--'"
                  class="text-down"
                  @click="goRenewOrder(row)"
                  >{{ row.sellNum }}</span
                >
                <span v-else>{{ row.sellNum }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="isImei" label="是否填写串号" align="center">
              <template slot-scope="{ row }">
                <span>{{ row.isImei == true ? "是" : "否" }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="isVoucher"
              label="是否需要上传购买凭证"
              align="center"
            >
              <template slot-scope="{ row }">
                <span>{{ row.isVoucher == true ? "是" : "否" }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="modifyRecordNum"
              label="商品修改记录"
              align="center"
            >
              <template slot-scope="{ row }">
                <span
                  v-if="row.modifyRecordNum && row.modifyRecordNum != '--'"
                  class="text-down"
                  @click="openStoreList(row)"
                  >{{ row.modifyRecordNum }}</span
                >
                <span v-else>{{ row.modifyRecordNum }}</span>
              </template>
            </el-table-column>
            <!-- 操作 -->
            <el-table-column
              fixed="right"
              label="操作"
              width="180"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  @click="handleOperate(scope.row, 'edit')"
                  v-if="auditStatus == '00'"
                  type="primary"
                  round
                  size="small"
                  >修改商品</el-button
                >
                <el-button
                  @click="handleOperate(scope.row, 'detail')"
                  v-if="auditStatus == '03'"
                  type="primary"
                  round
                  size="small"
                  >商品详情</el-button
                >
                <el-button
                  @click="handleOperate(scope.row, 'reUp')"
                  v-if="auditStatus == '05' || auditStatus == '10'"
                  type="primary"
                  round
                  size="small"
                  >重新上架</el-button
                >
                <el-button
                  @click="handleBtn(scope.row, 'down')"
                  v-if="auditStatus == '03'"
                  type="danger"
                  round
                  size="small"
                  >下架</el-button
                >
                <el-button
                  @click="handleBtn(scope.row, 'up')"
                  v-if="auditStatus == '00'"
                  type="success"
                  round
                  size="small"
                  >上架</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="orderPagina">
        <el-pagination
          background
          :current-page="pages.currentPage"
          :page-size="10"
          layout="total, prev, pager, next,jumper"
          :total="this.pages.total"
          class="el-pagination-c"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    <div
      v-else
      style="
        width: 100%;
        text-align: center;
        padding: 80px 0;
        font-size: 24px;
        color: #666666;
        background: white;
        font-weight: bold;
      "
    >
      暂无商品
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :width="`${800}px`"
      title="查看旧机照片"
      :visible="imgShow"
      @close="imgClose"
      top="5%"
    >
      <div class="img-box">
        <div class="img-tips-box">
          <div
            @click="chooseImages(0)"
            class="img-tips"
            :class="imgShowOnly ? 'img-tips-choose' : 'img-tips-default'"
          >
            旧机照片
          </div>
          <div
            v-if="this.DialogImgList[1].length > 0"
            @click="chooseImages(1)"
            class="img-tips"
            :class="imgShowOnly ? 'img-tips-default' : 'img-tips-choose'"
          >
            补拍照片
          </div>
        </div>
        <div class="img-show">
          <div class="imgs-num" v-if="DialogImgList[imgIndex].length > 0">
            {{ imgShowIndex + 1 }}/{{ DialogImgList[imgIndex].length }}
          </div>
          <div class="block">
            <viewer :images="DialogImgList[imgIndex]">
              <el-carousel trigger="click" height="80vh" @change="getindex">
                <el-carousel-item
                  v-for="item in this.DialogImgList[this.imgIndex]"
                  :key="item.imgNo"
                >
                  <div class="sec_img">
                    <img :src="item.img" alt="" />
                  </div>
                </el-carousel-item>
              </el-carousel>
            </viewer>
          </div>
          <!-- <LookImg :images="imgList"/> -->
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="导出数据显示"
      :visible="excelVisible"
      :close-on-click-modal="false"
      :width="`${500}px`"
      @close="excelVisible = false"
      top="15%"
    >
      <div style="display: flex; margin: 10px 20px">
        <div
          style="
            width: 80px;
            line-height: 30px;
            height: 30px;
            color: #666666;
            font-size: 14px;
          "
        >
          选时间段
        </div>
        <el-date-picker
          size="small"
          v-model="valueTime"
          type="daterange"
          range-separator="至"
          value-format="timestamp"
          :default-time="['00:00:00', '23:59:59']"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
      <div style="margin: 40px 0; float: right">
        <el-button @click="excelVisible = false" size="mini">取消</el-button>
        <el-button
          @click="submitExcel"
          :loading="exportLoading"
          type="primary"
          size="mini"
          >确认导出</el-button
        >
      </div>
    </el-dialog>
    <GlobalDialog
      :title="dialogTitle"
      :show="dialogVisibleOrder"
      :width="600"
      top="10vh"
      @resetPopupData="resetPopupData"
      @submitPopupData="submitPopupData"
      @onClose="resetPopupData"
    >
      <span>{{ dialogcancel.remark || "无" }}</span>
    </GlobalDialog>

    <el-dialog
      :close-on-click-modal="false"
      :width="`${800}px`"
      title="查看报价记录"
      :visible="viewrecords"
      @close="viewrecordsClose"
      top="15%"
      bottom="10%"
    >
      <div class="table_list" style="padding-bottom: 20px">
        <el-table
          :data="getUpdatedQuoteLog"
          max-height="300"
          border
          style="width: 100%"
          id="excelOrder"
        >
          <el-table-column
            prop="rank"
            width="70"
            label="报价次序"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="quoteTime"
            width="160"
            label="报价时间"
            align="center"
          ></el-table-column>
          <el-table-column label="报价人" align="center">
            <template slot-scope="{ row }">
              <span
                >{{ row.exclusiveQuoterName }}-{{
                  row.isMajor
                    ? "创建人"
                    : row.positionType == "01"
                    ? "子账号"
                    : "报价师"
                }}</span
              >
            </template>
          </el-table-column>
          <el-table-column label="报价金额" align="center">
            <template slot-scope="{ row }">
              <span>￥{{ row.quotePrice }}</span>
              <div>
                <el-tag
                  type="danger"
                  size="small"
                  effect="plain"
                  v-if="row.isInside"
                  >内部加价</el-tag
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column label="报价备注" align="center">
            <template slot-scope="{ row }">
              <el-tooltip
                v-if="row.quoteNote"
                class="item"
                effect="dark"
                :content="row.quoteNote"
                placement="top"
              >
                <div class="quoteNotecss">
                  {{ row.quoteNote }}
                </div>
              </el-tooltip>
              <span v-else>--</span>
            </template>
          </el-table-column>
        </el-table>
        <div
          style="color: #0981ff; font-size: 16px; margin: 20px 0"
          v-if="remakeQuoteLog && remakeQuoteLog.length"
        >
          补拍后报价记录
        </div>
        <el-table
          v-if="remakeQuoteLog && remakeQuoteLog.length"
          :data="remakeQuoteLog"
          max-height="300"
          border
          style="width: 100%"
          id="remakeOrder"
        >
          <el-table-column
            prop="rank"
            width="70"
            label="报价次序"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="remakeTime"
            width="100"
            label="补拍时间"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="quoteTime"
            width="100"
            label="报价时间"
            align="center"
          ></el-table-column>
          <el-table-column label="报价人" align="center">
            <template slot-scope="{ row }">
              <span
                >{{ row.exclusiveQuoterName }}-{{
                  row.isMajor
                    ? "创建人"
                    : row.positionType == "01"
                    ? "子账号"
                    : "报价师"
                }}</span
              >
            </template>
          </el-table-column>
          <el-table-column min-width="100" label="报价金额" align="center">
            <template slot-scope="{ row }">
              <span>￥{{ row.quotePrice }}</span>
              <div>
                <el-tag
                  type="danger"
                  size="small"
                  effect="plain"
                  v-if="row.isInside"
                  >内部加价</el-tag
                >
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="isNiceDevice"
            width="100"
            label="是否标记靓机"
            align="center"
          >
            <template scope="{ row }">
              <span>{{ row.isNiceDevice == true ? "是" : "否" }}</span>
            </template>
          </el-table-column> -->
          <el-table-column label="报价备注" align="center">
            <template slot-scope="{ row }">
              <el-tooltip
                v-if="row.quoteNote"
                class="item"
                effect="dark"
                :content="row.quoteNote"
                placement="top"
              >
                <div class="quoteNotecss">
                  {{ row.quoteNote }}
                </div>
              </el-tooltip>
              <span v-else>--</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- 启用禁用提示框 -->
    <el-dialog
      class="acc_dialog"
      title="退单提示"
      :visible.sync="revokeShow"
      :close-on-click-modal="false"
      width="500px"
      @closed="revokeClose"
    >
      <div
        style="font-size: 14px; color: rgb(255, 104, 123); margin: 0 0 10px 0"
      >
        说明：仅创建人、子账号可进行退单，退单须保证员工奖励余额充足，退单后订单获得的门店返利、红包、机款将退回到回收商账户。
      </div>
      <div style="margin-bottom: 20px; font-size: 16px; text-align: center">
        是否确认撤销该订单？
      </div>
      <div class="command" style="margin-bottom: 20px">
        <div style="margin-right: 10px">撤销原因:</div>
        <el-input
          style="width: 368px"
          maxlength="50"
          type="textarea"
          :rows="3"
          placeholder="请填写撤销原因，最多50字"
          v-model="revokeParams.refundRemark"
        >
        </el-input>
      </div>
      <div class="command">
        <div>登录密码：</div>
        <el-input
          type="password"
          v-model="revokeParams.password"
          placeholder="请输入登录密码"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="revokeClose">取消</el-button>
        <el-button type="primary" :loading="btnLoading" @click="revokeSure"
          >确定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      class="add_price_dialog"
      title="加价详情"
      :visible.sync="plusPriceIF"
      :close-on-click-modal="false"
      width="650px"
      @closed="plusPriceClose"
    >
      <div v-if="pcaddPric && pcaddPric.addPrice">
        <div class="add-price-title">返利加价</div>
        <div class="add-price-conent">
          <ul class="onlyul">
            <li class="firstli">
              <div>
                申请加价金额: ￥{{ pcaddPric.addPrice || "" }}
                <span
                  class="firstli_span"
                  v-if="pcaddPric.addPriceUseType == '02'"
                  >(可加价范围: 1-{{ pcaddPric.addMaxPrice }})</span
                >
                <span
                  class="firstli_span"
                  v-if="pcaddPric.addPriceUseType == '01'"
                  >(挪用返利比例: {{ pcaddPric.addPriceRate }}%)</span
                >
              </div>
              <div>
                申请人员: {{ pcaddPric.applyStaffName }}-{{
                  pcaddPric.applyStaffMobile
                }}-{{
                  pcaddPric.applyIsMajor
                    ? "创建人"
                    : pcaddPric.applyStaffType == "01"
                    ? "子账号"
                    : pcaddPric.applyStaffType == "02"
                    ? "总监"
                    : pcaddPric.applyStaffType == "03"
                    ? "店长"
                    : pcaddPric.applyStaffType == "04"
                    ? "店员"
                    : ""
                }}
              </div>
            </li>
            <li class="secondli">
              <div>批准加价金额: ￥{{ pcaddPric.passAddPrice }}</div>
              <div v-if="pcaddPric.auditStaffName">
                审核授权人:{{ pcaddPric.auditStaffName }}-{{
                  pcaddPric.auditStaffMobile
                }}-{{
                  pcaddPric.auditIsMajor
                    ? "创建人"
                    : pcaddPric.auditStaffType == "01"
                    ? "子账号"
                    : pcaddPric.auditStaffType == "02"
                    ? "总监"
                    : pcaddPric.auditStaffType == "03"
                    ? "店长"
                    : pcaddPric.auditStaffType == "04"
                    ? "店员"
                    : ""
                }}
              </div>
            </li>
            <li style="margin-bottom: 20px" v-if="pcaddPric.auditStaffName">
              审核授权时间: {{ pcaddPric.auditTime }}
            </li>
            <li
              style="margin-bottom: 9px; height: 1px"
              v-if="!pcaddPric.auditStaffName"
            ></li>
          </ul>
        </div>
      </div>
      <div v-if="pcaddPric && pcaddPric.usdAllAngPow">
        <div class="add-price-title">红包加价</div>
        <div class="add-price-conent">
          <ul class="onlyul">
            <li class="firstli">
              使用红包加价：￥{{ pcaddPric.usdAllAngPow || 0 }} (店员红包：￥{{
                pcaddPric.usdAngPowStaff || 0
              }}，店长红包：￥{{ pcaddPric.usdAngPowSmStaff || 0 }})
            </li>
            <li class="secondli">
              剩余红包：￥{{ pcaddPric.lastAllAngPow }} (店员红包：￥{{
                pcaddPric.angPowStaff || 0
              }}，店长红包：￥{{ pcaddPric.angPowSmStaff || 0 }})
            </li>
            <li style="margin-bottom: 9px; height: 1px"></li>
          </ul>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="从账号信息"
      :visible.sync="subInfoShow"
      :close-on-click-modal="false"
      width="300px"
      @closed="subInfoClose"
    >
      <div style="font-size: 14px; color: #333333; padding-bottom: 21px">
        <div class="flex" style="margin-bottom: 20px">
          <span style="margin-bottom: 10px">微信头像：</span
          ><img
            style="width: 70px; height: 70px; border-radius: 50%"
            :src="subInfo.img"
            alt=""
          />
        </div>
        <div class="flex" style="margin-bottom: 20px">
          <span>微信昵称：</span
          ><span style="color: #666666">{{ subInfo.nickName }}</span>
        </div>
        <div class="flex" style="margin-bottom: 20px">
          <span>从账号姓名：</span
          ><span style="color: #666666">{{ subInfo.staffName }}</span>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      class="acc_dialog"
      title="内部加价详情"
      :visible.sync="insideInfoShow"
      :close-on-click-modal="false"
      width="500px"
    >
      <ul class="onlyul">
        <li class="firstli">
          期望成交金额: ￥{{ insideInfo.applyRealPrice || "" }}
        </li>
        <li class="secondli">批准成交金额: ￥{{ insideInfo.passAddPrice }}</li>
        <li>
          申请人员: {{ insideInfo.companyApplyStaffName }}-{{
            insideInfo.companyApplyStaffMobile
          }}-{{
            insideInfo.companyApplyIsMajor
              ? "创建人"
              : insideInfo.companyApplyStaffType == "01"
              ? "子账号"
              : insideInfo.companyApplyStaffType == "02"
              ? "总监"
              : insideInfo.companyApplyStaffType == "03"
              ? "店长"
              : insideInfo.companyApplyStaffType == "04"
              ? "店员"
              : ""
          }}
        </li>

        <li v-if="insideInfo.merchantAuditStaffName">
          审核授权人：{{ insideInfo.merchantAuditStaffName }}-{{
            insideInfo.merchantAuditStaffMobile
          }}-{{
            insideInfo.merchantAuditIsMajor
              ? "创建人"
              : insideInfo.merchantAuditStaffType == "01"
              ? "子账号"
              : "报价师"
          }}
        </li>
        <li style="margin-bottom: 20px" v-if="insideInfo.auditTime">
          审核授权时间: {{ insideInfo.auditTime }}
        </li>
      </ul>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :width="`${800}px`"
      title="补拍记录"
      :visible="remakeRecordsShow"
      @close="remakeRecordsShow = false"
      top="15%"
      bottom="10%"
    >
      <div class="table_list autoshow" style="padding-bottom: 20px">
        <el-table
          v-loading="remakeloading"
          :data="remakeImgList"
          max-height="300"
          border
          style="width: 100%"
          id="remakeList"
        >
          <el-table-column
            prop="index"
            type="index"
            label="序号"
            align="center"
          ></el-table-column>
          <el-table-column width="100" label="补拍类型" align="center">
            <template slot-scope="{ row }">
              <span>{{
                row.remakeType == "01" ? "主动补拍" : "要求补拍"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column min-width="100" label="申请补拍时间" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.applyTime || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="申请补拍人" align="center">
            <template slot-scope="{ row }">
              <span v-if="row.applyStaffId"
                >{{ row.applyStaffName }}-{{
                  row.applyIsMajor
                    ? "创建人"
                    : row.applyStaffType == "01"
                    ? "子账号"
                    : "报价师"
                }}</span
              >
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="remakeTime"
            min-width="100"
            label="完成补拍时间"
            align="center"
          ></el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dealDetailProps.show"
      :title="dealDetailProps.title"
      :before-close="() => (dealDetailProps.show = false)"
      width="30%"
    >
      <!-- 已确认 -->
      <div v-if="dealDetailProps.type">
        <div class="deal_detail_title">
          回收商成交价：{{ dealDetailProps.data.quotePrice }}
        </div>
        <div class="deal_detail_inner">
          <div class="deal_detail_line-title">
            回收商实收价（扣除差异）：{{ dealDetailProps.data.netQuotePrice }}
          </div>
          <div class="deal_detail_line-title">
            差异金额 ：<span class="deal_detail_line-tips-red"
              >-{{ dealDetailProps.data.depreciatePrice }}</span
            >
          </div>
        </div>
        <div class="deal_detail_title">
          订单总利润：{{ dealDetailProps.data.orderRebate }}
        </div>
        <div class="deal_detail_inner">
          <div class="deal_detail_line">
            <p class="deal_detail_line-title">
              公司返利：{{ dealDetailProps.data.allAddPrice }}
            </p>
            <p class="deal_detail_line-tips">
              （<span class="deal_detail_line-tips-blue"
                >+门店返利：{{
                  dealDetailProps.data.storeAddPrice
                }}；+预留返利：{{ dealDetailProps.data.delayAddPrice }}；</span
              >
              <span class="deal_detail_line-tips-red"
                >-加价挪用：{{ dealDetailProps.data.useAddPrice }}</span
              >）
            </p>
          </div>
          <div class="deal_detail_line">
            <p class="deal_detail_line-title">
              员工红包：{{ dealDetailProps.data.angPow }}
            </p>
            <p class="deal_detail_line-tips">
              --店长：实得红包：{{ dealDetailProps.data.angPowSmStaff }}
              <span class="deal_detail_line-tips-blue" style="margin-left: 16px"
                >+计算红包：{{
                  dealDetailProps.data.orderAngPowSmStaff
                }}；</span
              >
              <span style="margin-left: 10px" class="deal_detail_line-tips-red"
                >-挪用红包{{ dealDetailProps.data.usdAngPowSmStaff }}</span
              >
            </p>
            <p class="deal_detail_line-tips">
              --店员：实得红包：{{ dealDetailProps.data.angPowStaff
              }}<span
                class="deal_detail_line-tips-blue"
                style="margin-left: 16px"
                >+计算红包：{{ dealDetailProps.data.orderAngPowStaff }}；</span
              ><span class="deal_detail_line-tips-red" style="margin-left: 10px"
                >-挪用红包{{ dealDetailProps.data.usdAngPowStaff }}</span
              >
            </p>
          </div>
          <div class="deal_detail_line">
            <p class="deal_detail_line-title">
              门店压价金额：{{ dealDetailProps.data.orderCutPrice }}
            </p>
            <p class="deal_detail_line-tips">
              --公司压价返利：{{
                dealDetailProps.data.companyRebate
              }}；店长压价提成：{{
                dealDetailProps.data.cutPriceSmStaff
              }}；店员压价提成：{{ dealDetailProps.data.cutPriceStaff }}
            </p>
          </div>
          <div class="deal_detail_line">
            <p class="deal_detail_line-title">
              员工创收奖励（未加价提成）：{{
                dealDetailProps.data.addPriceToStaff
              }}
            </p>
          </div>
          <div class="deal_detail_line">
            <p class="deal_detail_line-title">
              线上回收员工分享奖励：{{
                dealDetailProps.data.miniMallShareReward
              }}
            </p>
          </div>
        </div>
        <div class="deal_detail_title">
          顾客成交价：{{ dealDetailProps.data.userPrice }}
        </div>
      </div>
      <!-- 未确认 -->
      <div v-else>
        <div class="deal_detail_title">
          回收商报价：{{ dealDetailProps.data.quotePrice }}
        </div>
        <div class="deal_detail_title">
          订单总利润：{{ dealDetailProps.data.orderRebate }}
        </div>
        <div class="deal_detail_inner">
          <div class="deal_detail_line">
            <p class="deal_detail_line-title">
              公司返利：{{ dealDetailProps.data.allAddPrice }}
            </p>
          </div>
          <div class="deal_detail_line">
            <p class="deal_detail_line-title">
              员工红包：{{ dealDetailProps.data.angPow }}
            </p>
            <p class="deal_detail_line-tips">
              --店长：应得红包：{{ dealDetailProps.data.angPowSmStaff }}
              <span class="deal_detail_line-tips-blue" style="margin-left: 16px"
                >+设置红包：{{ dealDetailProps.data.orderAngPowSmStaff }}</span
              ><span style="margin-left: 10px" class="deal_detail_line-tips-red"
                >-挪用金额{{ dealDetailProps.data.usdAngPowSmStaff }}</span
              >
            </p>
            <p class="deal_detail_line-tips">
              --店员：应得红包：{{ dealDetailProps.data.angPowStaff }}
              <span class="deal_detail_line-tips-blue" style="margin-left: 16px"
                >+设置红包：{{ dealDetailProps.data.orderAngPowStaff }}</span
              ><span class="deal_detail_line-tips-red" style="margin-left: 10px"
                >-挪用金额{{ dealDetailProps.data.usdAngPowStaff }}</span
              >
            </p>
          </div>
          <div class="deal_detail_line">
            <p class="deal_detail_line-title">
              门店压价金额：{{ dealDetailProps.data.orderCutPrice }}
            </p>
          </div>
          <div class="deal_detail_line" style="margin-bottom: 0">
            <p class="deal_detail_line-title">
              线上回收分享奖励：{{ dealDetailProps.data.miniMallShareReward }}
            </p>
          </div>
        </div>
        <div class="deal_detail_title">
          顾客成交价：{{ dealDetailProps.data.userPrice }}
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dealDetailProps.show = false">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 旧机功能情况 -->
    <el-dialog
      v-bind="imeiTestProps"
      :before-close="() => (imeiTestProps.show = false)"
      :visible.sync="imeiTestProps.show"
    >
      <div v-loading="imeiTestProps.isLoadding" class="function_box">
        <!-- 旧机基本情况所有情况都有--新旧/外部 -->
        <div class="test-info">
          <Title title="旧机基本情况" />
          <!-- 没有机型名称且不是老年机或者功能机，取phoneName字段(新询价方案也需要展现旧机相关信息和规格) -->
          <TestDeviceInfo
            :externalorderType="externalorderType"
            :datainfo="detailData"
          />
        </div>
        <div>
          <!-- 估价单验机报告 -->
          <div class="test-box">
            <div
              class="test-result"
              v-if="detailData.functionView.errorList.length"
            >
              <Title
                :title="
                  '异常项（共' +
                  detailData.functionView.errorList.length +
                  '项）'
                "
              />
              <!-- 旧机无系统检测 -->
              <div
                class="mb10"
                v-if="
                  detailData.unableDetectionCause &&
                  detailData.detectionType == '01'
                "
              >
                <span class="fs16">旧机无法系统检测原因：</span>
                <span class="lv_fc_red fs16">{{
                  detailData.unableDetectionCause || "--"
                }}</span>
              </div>
              <div
                class="mb10"
                style="display: flex; justify-content: space-between"
                v-if="detailData.detectionType == '02'"
              >
                <span class="fs16"
                  >检测机型：{{ detailData.detectionModel || "--" }}</span
                >
                <span class="fs16"
                  >录入串号：{{ detailData.imei || "--" }}</span
                >
              </div>
              <TestTable
                :externalorderType="externalorderType"
                :table-data="detailData.functionView.errorList"
              ></TestTable>
            </div>
            <div
              class="test-result"
              style="margin-top: 20px"
              v-if="detailData.functionView.normalList.length"
            >
              <Title
                :title="
                  '正常项（共' +
                  detailData.functionView.normalList.length +
                  '项）'
                "
              />
              <TestTable
                :externalorderType="externalorderType"
                :table-data="detailData.functionView.normalList"
              ></TestTable>
            </div>
          </div>
        </div>
        <!-- 新增店员备注--所有情况下都有 -->
        <div style="margin: 15px 0 25px 0">
          <Title title="店员备注" />
          <Remark
            :remark="detailData.remark"
            :againPhotoRemark="detailData.againPhotoRemark"
            :aprAgreementRemark="detailData.aprAgreementRemark"
          />
        </div>
      </div>
      <div slot="footer">
        <el-button
          v-if="imeiTestProps.type === '01'"
          @click="imeiTestProps.show = false"
          plain
          type="primary"
          >关闭
        </el-button>
        <div v-else>
          <el-button @click="imeiTestProps.show = false">取 消</el-button>
          <el-button type="primary" @click="imeiTestProps.show = false"
            >确 定</el-button
          >
        </div>
      </div>
    </el-dialog>

    <!-- 抽屉 -->
    <el-drawer
      :title="drawerDialogTitle"
      :before-close="cancelForm"
      :visible.sync="drawerDialog"
      direction="rtl"
      custom-class="demo-drawer"
      :wrapper-closable="false"
      size="40%"
      ref="drawer"
    >
      <el-form
        :model="drawerInitData"
        ref="drawerForm"
        label-width="140px"
        class="demo-ruleForm"
        :rules="drawerFormRules"
      >
        <div class="top_setion">
          <div>
            <span
              :style="{ color: cutindex == '01' ? '#0981FF' : '' }"
              @click="cutDetail('01')"
              >基本信息</span
            >
            <span
              :style="{ color: cutindex == '02' ? '#0981FF' : '' }"
              @click="cutDetail('02')"
              >商品详情</span
            >
          </div>
          <div style="margin-right: 20px" v-if="cutindex == '01'">
            <el-button @click="previewImg('https://img.fanxinghuishou.cn/20240930/252250710.png')" type="warning" size="small" plain
              >查看示例</el-button
            >
          </div>
        </div>
        <div v-if="cutindex == '01'">
          <el-form-item class="el_from" label="商品名称：" prop="productName">
            <el-input
              style="width: 80%"
              size="small"
              placeholder="输入商品名称,例如iPhone 15 256G 黑色"
              v-model="drawerInitData.productName"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item class="el_from" label="商品编码：" prop="productCode">
            <el-input
              style="width: 80%"
              size="small"
              placeholder="输入商品编码"
              v-model.trim="drawerInitData.productCode"
              clearable
            ></el-input>
            <span
              v-if="!edit"
              class="text-down"
              style="margin-left: 10px"
              @click="autoCode"
              >自动生成</span
            >
          </el-form-item>
          <el-form-item class="el_from" label="分类：" prop="typeCode">
            <el-select
              filterable=""
              v-model="drawerInitData.typeCode"
              style="width: 80%"
              clearable
              placeholder="请选择分类"
              size="small"
            >
              <el-option
                v-for="item in option"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="el_from" label="商品售价：" prop="sellPrice">
            <el-input
              style="width: 80%"
              size="small"
              placeholder="请输入正整数"
              maxlength="5"
              v-model.number="drawerInitData.sellPrice"
              clearable
            ></el-input>
            <span style="margin-left: 10px">元</span>
          </el-form-item>
          <el-form-item class="el_from" label="商品成本：" prop="cost">
            <el-input
              style="width: 80%"
              size="small"
              placeholder="请输入正整数"
              maxlength="5"
              v-model.number="drawerInitData.cost"
              clearable
            ></el-input>
            <span style="margin-left: 10px">元</span>
          </el-form-item>
          <el-form-item
            class="el_from"
            label="商品数量："
            :prop="edit ? 'productTotalNum' : 'stock'"
          >
            <el-input
              v-if="!edit"
              :disabled="edit && editNum"
              @change="editProdNum"
              style="width: 80%"
              maxlength="5"
              size="small"
              placeholder="请输入正整数"
              v-model.number="drawerInitData.stock"
              clearable
            ></el-input>
            <el-input
              v-if="edit"
              :disabled="edit && editNum"
              @change="editProdNum"
              style="width: 80%"
              maxlength="5"
              size="small"
              placeholder="请输入正整数"
              v-model.number="drawerInitData.productTotalNum"
              clearable
            ></el-input>
            <span style="margin-left: 10px">个</span>
            <span
              v-if="edit"
              class="text-down"
              style="margin-left: 10px"
              @click="editNum = false"
              >修改</span
            >
            <div v-if="edit">
              <span style="color: #0981ff; cursor: pointer"
                >已销售：{{ drawerInitData.sellNum }}</span
              >
              <span style="margin-left: 50px; color: #0981ff; cursor: pointer"
                >当前库存：{{ drawerInitData.stock }}</span
              >
            </div>
          </el-form-item>
          <el-form-item class="el_from" label="有效期：" prop="expireTime">
            <el-date-picker
              v-model="drawerInitData.expireTime"
              type="daterange"
              range-separator="～"
              start-placeholder="生效日期"
              :picker-options="pickerOptions"
              end-placeholder="结束日期"
              style="width: 40%"
              size="small"
              format="yyyy-MM-dd"
              @input="$forceUpdate()"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item class="el_from" label="商品备注：" prop="note">
            <el-input
              type="textarea"
              v-model="drawerInitData.note"
              placeholder="请输入备注（最多20字）"
              style="width: 80%"
              maxlength="20"
              :autosize="{ minRows: 1, maxRows: 2 }"
              resize="none"
              show-word-limit
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item class="el_from" label="补贴金额：" prop="subsidyPrice">
            <el-input
              style="width: 80%"
              size="small"
              maxlength="5"
              placeholder="请输入正整数"
              v-model.number="drawerInitData.subsidyPrice"
              clearable
            ></el-input>
            <span style="margin-left: 10px">元</span>
          </el-form-item>
          <el-form-item class="el_from" label="是否填写串号：" prop="isImei">
            <el-radio-group v-model="drawerInitData.isImei">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item class="el_from" label="是否上传凭证：" prop="isVoucher">
            <el-radio-group v-model="drawerInitData.isVoucher" disabled>
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <div style="font-weight: bold; padding-left: 40px; font-size: 14px">
            设置赠品规则
          </div>
          <el-form-item
            required
            class="el_from"
            label="是否可设置赠品："
            prop="isOpenGift"
          >
            <el-radio-group v-model="drawerInitData.isOpenGift">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <div class="temsGift" v-if="drawerInitData.isOpenGift">
            <el-form-item
              required
              class="el_from"
              label="赠送条件："
              prop="giftRuleType"
            >
              <el-radio-group v-model="drawerInitData.giftRuleType">
                <el-radio label="00">不压价也可赠送</el-radio>
                <el-radio label="01">压价金额≥赠品成本时可赠送</el-radio>
                <el-radio label="02">压价金额≥赠品售价时可赠送</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <!-- <el-form-item class="el_from" label="补贴规则：" prop="subsidyRule">
            <el-input
              type="textarea"
              v-model="drawerInitData.subsidyRule"
              placeholder="请输入规则说明（最多200字）"
              maxlength="200"
              :autosize="{ minRows: 4, maxRows: 4 }"
              resize="none"
              style="width: 80%"
              show-word-limit
              size="small"
            ></el-input>
          </el-form-item> -->
        </div>
        <div v-else>
          <div class="icon_content">
            <div class="section_time">
              <span style="color: #ff687b">*</span>
              <p>商品缩略图：</p>
            </div>
            <ElImgUpload
              key="clickLogo"
              :exist-image="drawerInitData.productThumbnail"
              @handleDelete="handleDelete()"
              @handleChange="handleChange($event)"
            />
            <span style="color: #ff687b; font-size: 14px"
              >最多上传1张图片，大小不超过2M，图片尺寸为180px
              *180px，格式为JPG或PNG</span
            >
          </div>
          <div style="position: relative;">
            <el-form-item
            required
            class="el_from"
            label="是否启用商品介绍:"
            prop="isOpenGift"
          >
            <el-radio-group v-model="drawerInitData.isDesciption">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <div class="seaShili" v-if="drawerInitData.isDesciption">
              <el-button @click="previewImg('https://img.fanxinghuishou.cn/20240930/056126143.png')" type="warning" size="small" plain
                >查看示例</el-button
              >
            </div>
          </div>
          <div class="flex-box" v-if="drawerInitData.isDesciption">
            <j-editor
              @handleEditContent="handleEditContent"
              @handleSettingEditContent="handleSettingEditContent"
              type="CUSTOMER_SERVICE_PROTOCOL"
            ></j-editor>
          </div>
          <el-form-item
            required
            class="el_from"
            label="是否启用商品卖点:"
            prop="isOpenGift"
          >
            <el-radio-group v-model="drawerInitData.isSellingPoint">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <div
            style="
              padding-left: 40px;
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
            v-if="drawerInitData.isSellingPoint"
          >
            <div>
              <el-button
                icon="el-icon-plus"
                @click="addimageIcon"
                size="mini"
                type="primary"
                >添加</el-button
              >
              <span style="color: #ff687b; font-size: 14px; margin-left: 10px"
                >最多可添加5个卖点</span
              >
            </div>
            <div style="margin-right: 20px">
              <el-button @click="previewImg('https://img.fanxinghuishou.cn/20240930/713223678.png')" type="warning" size="small" plain
                >查看示例</el-button
              >
            </div>
          </div>
          <div
            style="width: 90%; padding: 10px 0 0 40px"
            v-if="drawerInitData.isSellingPoint"
          >
            <el-table :data="tabletitleData">
              <el-table-column
                prop="date"
                label="图标"
                align="center"
                width="100px"
                type="index"
              >
                <template slot-scope="{ row, $index }">
                  <img :src="row.sellingPointIcon" alt="" />
                  <span @click="selectIcon(row, $index)" class="text-down"
                    >选择图标</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="sellingPointTitle"
                label="卖点标题"
                align="center"
              >
                <template slot-scope="{ row }">
                  <el-input
                    maxlength="10"
                    v-model="row.sellingPointTitle"
                    placeholder="请输入标题，最多10个字"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="detailed" label="详细介绍" align="center">
                <template slot-scope="{ row }">
                  <el-input
                    maxlength="50"
                    type="textarea"
                    autosize
                    v-model="row.detailed"
                    placeholder="非必填，最多50字"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column align="center" width="80px" label="操作">
                <template slot-scope="{ row, $index }">
                  <el-button
                    size="small"
                    @click="delItem(row, $index)"
                    type="danger"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="el_from footer" style="padding-bottom: 20px">
          <el-button size="small" @click="cancelForm">取消</el-button>
          <el-button size="small" type="primary" @click="handleClose"
            >确认</el-button
          >
        </div>
      </el-form>
    </el-drawer>
    <!-- 选择图标 -->
    <el-dialog
      title="选择图标"
      :visible.sync="InitiatereshootShow"
      :close-on-click-modal="false"
      width="600px"
      @closed="commandClosed"
    >
      <div style="margin-top: 20px">
        <p style="font-weight: bold">平台图标</p>
        <div class="Encourag_picture">
          <div
            class="ep_image"
            v-for="(item, index) in reshootimgList"
            :key="index"
            @click="
              () => {
                imageIndexnum = index;
                everyOneImg = item;
              }
            "
          >
            <img :src="item" alt="" />
            <img
              v-if="imageIndexnum === index"
              class="imgredion"
              src="https://img.fanxinghuishou.cn/20231007/687013453.png"
              alt=""
            />
            <img
              v-else
              class="imgredion"
              src="https://img.fanxinghuishou.cn/20231007/187057703.png"
              alt=""
            />
          </div>
        </div>
        <div>
          <div class="section_time">
            <p style="font-weight: bold">自定义图标</p>
          </div>
          <ElImgUpload
            key="clickLogo"
            :exist-image="everyOneImg"
            @handleDelete="handleeveryDelete()"
            @handleChange="handleeveryChange($event)"
          />
          <span style="color: #ff687b; font-size: 14px"
            >建议上传70*70px的图标</span
          >
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="InitiatereshootShow = false">取消</el-button>
        <el-button type="primary" @click.native="inmitsubmitSuccess()"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <!-- 商品修改记录 -->
    <el-dialog
      :close-on-click-modal="false"
      width="1400px"
      title="商品修改记录"
      :visible="storeShow"
      @close="storeClose"
      top="15%"
    >
      <div class="img-box">
        <div class="recordStyle">
          <span>商品编码：{{ productRecord.productCode }}</span>
          <span>商品名称：{{ productRecord.productName }}</span>
          <span>以旧换新补贴:{{ productRecord.subsidyPrice }}元</span>
        </div>
        <div class="table_list">
          <el-table
            :data="storeList"
            border
            style="width: 100%"
            id="excelOrder"
            :cell-style="rowStyle"
            @cell-click="Bargain"
          >
            <el-table-column
              prop="index"
              type="index"
              label="序号"
            ></el-table-column>
            <el-table-column
              prop="createStaffPcName"
              width="160"
              label="操作人"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="createTime"
              width="160"
              label="变更时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="sellPrice"
              width="160"
              label="变更后售价（元）"
              align="center"
            >
              <template slot-scope="{ row }">
                <div
                  :style="{
                    color:
                      row.sellPrice != row.sellPriceBefore ? 'red' : '#666',
                  }"
                >
                  {{ row.sellPriceBefore
                  }}<span v-if="row.sellPrice != row.sellPriceBefore"
                    >→{{ row.sellPrice }}</span
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="cost"
              width="160"
              label="变更后成本（元）"
              align="center"
            >
              <template slot-scope="{ row }">
                <span>{{ row.cost }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="stock"
              width="160"
              label="变更后商品数量"
              align="center"
            >
              <template slot-scope="{ row }">
                <div
                  :style="{
                    color: row.stock > row.stockBefore ? 'red' : '#666',
                  }"
                >
                  {{ row.stockBefore }}
                  <span v-if="row.stock != row.stockBefore"
                    >→{{ row.stock }}</span
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="periodEnd"
              label="变更后结束时间"
              align="center"
            >
              <template slot-scope="{ row }">
                <div
                  :style="{
                    color:
                      row.periodEnd != row.periodEndBefore ? 'red' : '#666',
                  }"
                >
                  {{ row.periodEndBefore
                  }}<span v-if="row.periodEnd != row.periodEndBefore"
                    >→{{ row.periodEnd }}</span
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="subsidyPrice"
              width="160"
              label="变更后补贴金额"
              align="center"
            >
              <template slot-scope="{ row }">
                <div
                  :style="{
                    color:
                      row.subsidyPrice > row.subsidyPriceBefore
                        ? 'red'
                        : '#666',
                  }"
                >
                  {{ row.subsidyPriceBefore
                  }}<span v-if="row.subsidyPrice != row.subsidyPriceBefore"
                    >→{{ row.subsidyPrice }}</span
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="storeShow = false">关 闭</el-button>
      </div>
    </el-dialog>
    <!-- 下架 -->
    <el-dialog
      title="操作提示"
      :visible.sync="usedDialogVisible"
      :close-on-click-modal="false"
      width="400px"
    >
      <div style="font-size: 16px; color: #666666; line-height: 50px">
        <div style="text-align: center">
          是否确认{{ isPut ? "下架" : "上架" }}该商品？
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="usedDialogVisible = false">取消</el-button>
        <el-button type="primary" @click.native="usedSuccess">确定</el-button>
      </span>
    </el-dialog>
    <el-image-viewer :zIndex="99999" v-if="showViewer" :on-close="() => {
      showViewer = false;
    }
      " :url-list="imgList" />
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import editor from "./component/editor";
import _api from "@/utils/request";
import { getHealthCode, openAction, setValue } from "@/utils/common";
import moment from "moment";
import ElImgUpload from "../../../components/global/components/elements/upload-element";
import { imeiTestProps } from "@/views/RecallOrder/initState";
import TestDeviceInfo from "@/views/RecallOrder/componets/TestDeviceInfo.vue";
import TestTable from "@/views/RecallOrder/componets/TestTable.vue";
import Title from "@/views/RecallOrder/componets/Title.vue";
import Remark from "@/views/RecallOrder/componets/Remark.vue";
export default {
  name: "OrderTable",
  components: {
    ElImageViewer,
    TestTable,
    TestDeviceInfo,
    Title,
    Remark,
    ElImgUpload,
    [editor.name]: editor,
  },
  props: {
    option: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    let checkNum = (rule, value, callback) => {
      const profit = this.drawerInitData.sellPrice - this.drawerInitData.cost;
      if (value > profit) {
        callback(new Error("补贴金额高于商品利润"));
      } else if (value <= 0) {
        callback(new Error("不能为0"));
      } else {
        callback();
      }
    };
    return {
      InitiatereshootShow: false,
      imageIndexnum: "",
      reshootimgList: [],
      tabletitleData: [],
      protocolData: {
        CUSTOMER_SERVICE_PROTOCOL: "",
      },
      cutindex: "01",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      currentRow: {},
      usedDialogVisible: false,
      copyNo: "",
      isPut: false,
      edit: false,
      isEditGoods: false,
      isReup: false,
      editNum: true,
      // 抽屉
      drawerDialog: false,
      paramsExcel: {},
      importVisible: false,
      drawerDialogTitle: "添加商品",
      drawerInitData: {
        productName: "",
        productCode: "",
        typeCode: "", //分类
        sellPrice: "", //商品售价
        cost: "",
        stock: "",
        sellNum: "",
        productTotalNum: 0,
        expireTime: "",
        note: "",
        giftRuleType: "00",
        isOpenGift: true,
        subsidyType: "00", //补贴类型
        subsidyPrice: "", //补贴金额
        isImei: true, //是否需要填写串号：
        isVoucher: true, //是否需要凭证：
        subsidyRule: "", //补贴规则
        productThumbnail: "", //	商品缩略图
        productDesciption: "", //	商品介绍
        sellingPointAddVos: [], //商品卖点信息
        isSellingPoint: false, //	是否启用商品卖点
        isDesciption: false, //是否启用商品介绍
      },
      drawerFormRules: {
        productName: [
          {
            required: true,
            trigger: "blur",
            message: "请输入商品名称",
          },
        ],
        productCode: [
          {
            required: true,
            trigger: "blur",
            message: "请输入商品编码",
          },
        ],
        typeCode: [
          {
            required: true,
            trigger: "blur",
            message: "请输入分类名称",
          },
        ],
        sellPrice: [
          {
            required: true,
            trigger: "blur",
            message: "请输入商品售价",
          },
          { type: "number", message: "请输入正整数" },
        ],
        cost: [
          {
            required: true,
            trigger: "blur",
            message: "请输入商品成本",
          },
          { type: "number", message: "请输入正整数" },
        ],
        productTotalNum: [
          {
            required: true,
            trigger: "blur",
            message: "请输入商品数量",
          },
          { type: "number", message: "请输入正整数" },
        ],
        stock: [
          {
            required: true,
            trigger: "blur",
            message: "请输入商品数量",
          },
          { type: "number", message: "请输入正整数" },
        ],
        expireTime: [
          {
            required: true,
            trigger: "blur",
            message: "请选择有效期",
          },
        ],
        subsidyType: [
          {
            required: true,
            trigger: "blur",
            message: "请输入补贴类型",
          },
        ],
        subsidyPrice: [
          {
            required: true,
            trigger: "blur",
            message: "请输入补贴金额",
          },
          { type: "number", message: "请输入正整数" },
          { validator: checkNum, trigger: "blur" },
        ],
        isImei: [
          {
            required: true,
            trigger: "blur",
            message: "请选择",
          },
        ],
        isVoucher: [
          {
            required: true,
            trigger: "blur",
            message: "请选择",
          },
        ],
        subsidyRule: [
          {
            required: true,
            trigger: "blur",
            message: "请输入补贴规则",
          },
        ],
      },
      optionState: [
        {
          label: "厂家补贴",
          value: "00",
        },
        {
          label: "加价补贴",
          value: "01",
        },
      ],
      baoPricestate: "", //订单状态
      imeiTestProps,
      externalorderType: "", //订单类型
      // 功能情况接口
      detailData: {
        functionView: {
          normalList: [],
          errorList: [],
        },
        basicFunctionList: [],
        plugFunctionList: [],
        informationList: [],
      },
      // 成交明细
      dealDetailProps: {
        show: false,
        data: {},
        // true代表已确认，fasle代表未确认
        type: false,
        title: "报价明细",
      },
      plusPriceIF: false,
      getUpdatedQuoteLog: [],
      remakeQuoteLog: [],
      viewrecords: false,
      remakeRecordsShow: false,
      remakeloading: false,
      remakeImgList: [],
      pcaddPric: null,
      // 导出弹窗
      valueTime: "",
      excelVisible: false,
      /*********** 新增 **********/
      imgShow: false,
      imgShowOnly: true,
      DialogImgList: [[], []],
      imgShowIndex: 0,
      imgIndex: 0,
      storeShow: false,
      enquiryDetailsShow: false,
      storeList: [],
      productRecord: {
        productCode: "",
        productName: "",
        subsidyPrice: "",
      },
      /*********** 新增 **********/
      pages: {
        total: 0,
        pageSize: 10,
        currentPage: 1,
      },
      revokeShow: false,
      revokeParams: {
        password: "",
        refundRemark: "",
        orderNo: "",
      },
      btnLoading: false,
      itemArr: [],
      itemTable: [],
      orderTableList: [],
      loading: false,
      dialogVisibleOrder: false,
      dialogTitle: "",
      dialogcancel: {
        remark: "",
      },
      loginStaffType: "",
      subInfoShow: false,
      insideInfoShow: false,
      insideInfo: {},
      subInfo: {
        img: "",
        staffName: "",
        nickName: "",
      },
      chxInfo: {},
      auditStatus: "00",
      applyNumber: {},
      isFilterStock: false,
      isFilterTime: false,
      importForm: {
        fileName: "",
      },
      importRules: {
        fileName: [
          {
            required: true,
            message: "仅支持.xls及.xlsx格式,单次上传大小不超过5M",
            trigger: "blur",
          },
        ],
      },
      exportLoading: false,
      iconselectIndex: "",
      everyOneImg: "",
      showViewer:false,
      imgList:[]
    };
  },
  created() {
    this.loginStaffType = JSON.parse(localStorage.getItem("user")).staffType;
    this.handleCurrentChange();
    this.platformIconSelect();
  },
  computed: {
    SeachParams() {
      console.log(this.$store.state.tagsView.SeachParams);
      return this.$store.state.tagsView.SeachParams;
    },
  },
  watch: {
    isFilterStock(val) {
      console.log(999, val);
      this.isFilterStock = val;
      this.pages.currentPage = 1;
      this.handleCurrentChange();
    },
    isFilterTime(val) {
      this.isFilterTime = val;
      this.pages.currentPage = 1;
      this.handleCurrentChange();
    },
    SeachParams(newval) {
      console.log(newval);
      this.pages.currentPage = 1;
      this.handleCurrentChange();
    },
  },
  methods: {
    previewImg(url){
      this.showViewer=true
      this.imgList=[url]
    },
    delItem(item, index) {
      console.log(item, index);
      this.tabletitleData.splice(index, 1);
    },
    commandClosed() {
      this.InitiatereshootShow = false;
      this.imageIndexnum = "";
      this.everyOneImg = "";
    },
    // 图标上传回调
    handleeveryChange(e) {
      this.everyOneImg = e;
    },
    handleeveryDelete(val) {
      this.everyOneImg = "";
    },
    selectIcon(data, index) {
      console.log(data, index);
      this.iconselectIndex = index;
      this.InitiatereshootShow = true;
    },
    addimageIcon() {
      if (this.tabletitleData.length === 5) return;
      this.tabletitleData.push({
        detailed: "",
        sellingPointIcon: "",
        sellingPointTitle: "",
      });
    },
    inmitsubmitSuccess() {
      if (!this.everyOneImg) {
        return this.$message.error("请选择或上传图标图片！");
      }
      this.tabletitleData[this.iconselectIndex].sellingPointIcon =
        this.everyOneImg;
      this.InitiatereshootShow = false;
    },
    handleEditContent(html, type) {
      console.log(html, "html");
      this.protocolData[type] = html;
      console.log(this.protocolData);
      this.$forceUpdate();
    },
    handleSettingEditContent(set, type) {
      setTimeout(() => {
        set.html(this.protocolData.CUSTOMER_SERVICE_PROTOCOL);
      }, 300);
    },
    cutDetail(id) {
      this.cutindex = id;
    },
    // 图标上传回调
    handleChange(e) {
      console.log(e);
      this.drawerInitData.productThumbnail = e;
    },
    handleDelete(val) {
      console.log(val);
      this.drawerInitData.productThumbnail = "";
    },
    // 自动生成编码
    autoCode() {
      const uniqueId = "Prod" + Math.random().toString(36).substring(2, 9);
      return (this.drawerInitData.productCode = uniqueId);
    },
    // 修改商品数量
    editProdNum(val) {
      console.log(222, val);
    },
    //导入数据表格
    outexport() {
      this.importVisible = true;
    },
    onUploadList(event, type) {
      console.log(event.target.files, "eveny");
      this.paramsExcel.file = event.target.files;
      if (this.paramsExcel.file.length) {
        this.paramsExcel.excelName = event.target.files[0].name;
        this.importForm.fileName = event.target.files[0].name;
      }
    },
    //表格清理
    fileClear() {
      this.$refs.fileUpload.value = "";
      this.paramsExcel = {};
    },
    // 弹窗关闭
    exportinDialogClosed() {
      if (this.$refs["addForm"]) {
        this.$refs["addForm"].resetFields();
      } else {
        this.$refs["importForm"].resetFields();
      }
      this.importForm = {
        fileName: "",
      };
      this.$refs.fileUpload.value = "";
      this.paramsExcel = {};
    },
    //下载模板
    download() {
      const link = document.createElement("a");
      link.href = "/static/导入商品数据模板.xlsx";
      link.setAttribute("download", "导入商品数据模板.xlsx");
      document.body.appendChild(link);
      link.click();
    },
    // 确定导出
    uploadFile() {
      if (!this.paramsExcel.file || this.paramsExcel.file.length == 0) {
        return this.$message.error("请上传表格");
      }
      const fd = new FormData();
      console.log(this.paramsExcel);
      fd.append("file", this.paramsExcel.file[0]); //文件
      console.log(fd);
      this.repeatData = [];
      // 发起请求
      _api
        .readOutOrderNo(fd)
        .then((res) => {
          console.log("_RequestUploads_", res);
          if (res.code === 1) {
            this.importForm.fileName = "";
            this.$refs.fileUpload.value = "";
            this.$message({
              type: "success",
              message: "导入成功！",
            });
            this.importVisible = false;
            this.handleCurrentChange();
            if (res.data.length > 0) {
              //如果退单有数据，删除重复数据
              if (this.seachDataList.length > 0) {
                this.seachDataList.unshift(...res.data);
                //去重后加入退单中
                const uniqueArr = this.seachDataList.filter(
                  (item, index) =>
                    this.seachDataList.findIndex(
                      (i) => i.orderNoOneline === item.orderNoOneline
                    ) === index
                );
                this.seachDataList = uniqueArr;
              } else {
                this.seachDataList.unshift(...res.data);
              }
              //给定唯一变量
              this.seachDataList.forEach((item, inds) => {
                item.index = inds;
              });
            } else {
              this.$message({
                type: "warning",
                message: "请导入商品数据！",
              });
            }
            this.importVisible = false;
          } else {
            this.$message({
              type: "warning",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.importForm.fileName = "";
          this.$refs.fileUpload.value = "";
        });
    },
    // 上下架
    handleBtn(row, type) {
      this.currentRow = row;
      this.copyNo = row.copyNo;
      this.isPut = type == "down" ? true : false;
      this.usedDialogVisible = true;
    },
    //确认上下架
    usedSuccess() {
      if (this.isPut) {
        _api
          .downProduct({ productId: this.currentRow.productId })
          .then((res) => {
            if (res.code === 1) {
              this.$message.success(res.msg);
              this.usedDialogVisible = false;
              this.handleCurrentChange();
            }
          });
      } else {
        _api
          .putawayProduct({ productId: this.currentRow.productId })
          .then((res) => {
            if (res.code === 1) {
              this.$message.success(res.msg);
              this.usedDialogVisible = false;
              this.handleCurrentChange();
            }
          });
      }
    },
    // 添加商品-打开抽屉
    addProduct() {
      this.cutindex = "01";
      this.drawerDialog = true;
      this.drawerDialogTitle = "添加商品";
    },
    platformIconSelect() {
      _api.platformIconSelect().then((res) => {
        this.reshootimgList = res.data;
      });
    },
    // 抽屉
    handleClose() {
      if (!this.drawerInitData.productThumbnail) {
        return this.$message.error("请上传商品缩略图");
      }
      if (
        !this.protocolData.CUSTOMER_SERVICE_PROTOCOL &&
        this.drawerInitData.isDesciption
      ) {
        return this.$message.error("请填写商品介绍");
      }
      if (
        this.drawerInitData.isSellingPoint &&
        (this.tabletitleData.some((item) => !item.sellingPointIcon) ||
          this.tabletitleData.some((item) => !item.sellingPointTitle))
      ) {
        return this.$message.error("请完整填写商品买点！");
      }
      this.$refs["drawerForm"].validate((valid) => {
        if (valid) {
          console.log(this.drawerInitData, "tijiao");
          this.drawerInitData.periodStart = moment(
            this.drawerInitData.expireTime[0]
          ).format("x");
          this.drawerInitData.periodEnd = moment(
            this.drawerInitData.expireTime[1]
          ).format("x");
          this.drawerInitData.productDesciption =
            this.protocolData.CUSTOMER_SERVICE_PROTOCOL;
          this.drawerInitData.sellingPointList = this.tabletitleData;
          if (!this.isEditGoods || this.isReup) {
            _api.addProduct(this.drawerInitData).then((res) => {
              if (res.code === 1) {
                this.$message.success(res.msg);
                this.cancelForm();
                this.handleCurrentChange();
              }
            });
          } else if (this.isEditGoods) {
            _api.editProduct(this.drawerInitData).then((res) => {
              if (res.code === 1) {
                this.$message.success(res.msg);
                this.cancelForm();
                this.handleCurrentChange();
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    cancelForm() {
      this.drawerDialog = false;
      this.isEditGoods = false;
      this.isReup = false;
      this.edit = false;
      this.editNum = true;
      this.protocolData.CUSTOMER_SERVICE_PROTOCOL = "";
      this.tabletitleData = [];
      this.drawerInitData = {
        productName: "",
        productCode: "",
        typeCode: "", //分类
        sellPrice: "", //商品售价
        cost: "",
        stock: "",
        sellNum: "",
        expireTime: "",
        note: "",
        giftRuleType: "00",
        isOpenGift: true,
        subsidyType: "00", //补贴类型
        subsidyPrice: "", //补贴金额
        isImei: true, //是否需要填写串号：
        isVoucher: true, //是否需要上传凭证：
        subsidyRule: "", //补贴规则
        productThumbnail: "", //	商品缩略图
        productDesciption: "", //	商品介绍
        sellingPointAddVos: [], //商品卖点信息
        isSellingPoint: false, //	是否启用商品卖点
        isDesciption: false, //是否启用商品介绍
      };
      this.$refs["drawerForm"].resetFields();
      clearTimeout(this.timer);
    },
    openAction,
    //功能情况设置显示值
    setFunctionType(v) {
      let { isSystem, unableDetectionCause, functionList, isOtherTitileShow } =
        this.imeiTestProps;
      // 其他功能 系统检测||无法检测&&功能项存在&&（不是采货侠或者是采货侠订单且外部渠道为fx）
      if (
        (isSystem || unableDetectionCause) &&
        functionList.length &&
        (!v.isOneline || (v.isOneline && v.outType === "fx"))
      ) {
        isOtherTitileShow = true;
      } else {
        isOtherTitileShow = false;
      }
      this.imeiTestProps.isOtherTitileShow = isOtherTitileShow;
      // 02不是采货侠或者是采货侠订单且外部渠道为fx
      if (!v.isOneline || (v.isOneline && v.outType === "fx")) {
        return (this.imeiTestProps.type = "02");
      }
    },
    // 上述02类型  外部渠道盛达lb或者lb2，屏蔽正常开机选项
    setFunctionData(v) {
      const fineness = v.fineness ?? { fineness: [] };
      v.detectionInfo = v.detectionInfo ?? {};
      let {
        isFinenessShow,
        functionList,
        systemTestList,
        photoArr,
        allSystemTestList,
      } = this.imeiTestProps;
      const { cameraTestImgFront, cameraTestImgRear } = v.detectionInfo;
      systemTestList = JSON.parse(JSON.stringify(allSystemTestList));
      let finenessData = Array.isArray(fineness.fineness)
        ? fineness.fineness
        : [];
      functionList = Array.isArray(functionList) ? functionList : [];
      // 盛达外部去除是否开机
      if (v.outType === "lb" || v.outType === "lb2") {
        functionList = functionList.filter(
          (v) => v.faultName !== "是否正常开机"
        );
      }
      // 成色渲染 是采货侠 && 并且存在成色数据
      if (v.isOneline && fineness && finenessData.length) {
        isFinenessShow = true;
        finenessData = Array.isArray(finenessData) ? finenessData : [];
        finenessData = finenessData.map((item) => {
          if (v.outType === "lb" || v.outType === "lb2") {
            item.value = item.value ?? [];
            item.value = item.value.map((v) => {
              return {
                valueText: v.isNormal ? "正常" : "异常",
                isNormal: v.isNormal,
              };
            });
          }
          return {
            name: item.label,
            value: item.value,
          };
        });
      } else {
        isFinenessShow = false;
      }
      // 设置功能机
      functionList = functionList.map((v) => {
        return {
          name: v.faultName,
          state: v.faultAnswer,
          reason: v.faultCause,
        };
      });
      // 检测类型动态更改值的key
      const systemKeys = ["mobileNetworks", "wlan", "bluetooth"];
      if (v.detectionInfo) {
        // 设置系统验机项
        systemTestList = systemTestList.map((item) => {
          item.value = v.detectionInfo[item.key] ?? "--";
          //前三个，正常的就是系统验机，异常的话是人工验机
          if (systemKeys.indexOf(item.key) >= 0) {
            if (v.detectionInfo[item.key] === "01") {
              item.isSystem = true;
            } else {
              item.isSystem = false;
            }
          }
          // 存在值才进行替换
          if (v.detectionInfo[item.tipKey]) {
            item.tips = v.detectionInfo[item.tipKey].replaceAll("&", "       ");
          }
          return item;
        });
      }

      // 设置前置旧机照片
      if (cameraTestImgFront) {
        photoArr.push(cameraTestImgFront);
      }
      // 设置后置
      if (cameraTestImgRear) {
        photoArr.push(cameraTestImgRear);
      }
      this.imeiTestProps = {
        ...this.imeiTestProps,
        functionList,
        isFinenessShow,
        finenessData,
        systemTestList,
        photoArr,
      };
    },
    // 功能情况接口
    getDetail(orderNo) {
      _api.getInspectionReport({ orderNo }).then((res) => {
        this.detailData = res.data;
        if(res.data.againPhotoRemark){
          this.detailData.againPhotoRemark=res.data.againPhotoRemark.split("//")
        }else{
          this.detailData.againPhotoRemark=[]
        }
        this.imeiTestProps.isLoadding = false;
      });
    },
    // 功能情况
    getFunction(v, outType) {
      this.externalorderType = outType;
      // 显示弹窗
      this.imeiTestProps = {
        ...this.imeiTestProps,
        phoneName: "",
        // 检测项
        tableData: [],
        // 功能情况
        functionList: [],
        // 系统检测结果
        systemTestResult: [],
        // 是否无法检测
        unableDetectionCause: "",
        // 是否系统检测且存在检测结果
        isSystem: false,
        // 其他功能标题显示，原需求模糊，抄详情写
        isOtherTitileShow: false,
        // 其他功能表格 原需求模糊，抄详情写
        isOtherTableShow: false,
        // 是否显示成色
        isFinenessShow: false,
        // 成色数据
        finenessData: [],
        // 旧机照片
        photoArr: [],
        // 系统验机项
        systemTestList: [],
        orderMode: "", //下单模式
        funcDetail: {},
        show: true,
        isLoadding: true,
      };
      // 请求详情
      this.getDetail(v);
    },
    // 加价弹窗
    plusPrice(row) {
      console.log(row, "加价弹窗row");

      _api.orderaddPriceInfo({ orderNo: row.orderNo }).then((res) => {
        this.pcaddPric = res.data;
      });
      this.plusPriceIF = true;
    },
    // 内部加价弹窗
    isInsideInfo(row) {
      console.log(row, "内部审批弹窗row");
      _api.insideApplyInfo({ orderNo: row.orderNo }).then((res) => {
        this.insideInfo = res.data;
      });
      this.insideInfoShow = true;
    },

    rowStyle({ row, column, rowIndex, columnIndex }) {
      console.log(row);
      if (columnIndex == 8 && !(row.quoteNum == 0) && !(row.quoteNum == "--")) {
        return "text-decoration:underline;color:#21a4f1;cursor:pointer;";
      }
    },
    Bargain(row, column, cell, event) {
      if (
        !(row.quoteNum == 0) &&
        !(row.quoteNum == "--") &&
        column.property == "quoteNum"
      ) {
        console.log(row, "------------");
        // this.storeShow = false;
        this.viewrecords = true;
        _api
          .getUpdatedQuoteLog({
            merchantId: row.recycleMerchantId,
            orderNo: row.orderNo,
          })
          .then((res) => {
            console.log(res.data, "报价信息");
            this.getUpdatedQuoteLog = res.data.normal;
            this.remakeQuoteLog = res.data.remake;
          });
      }
    },

    // oplist 查看报价记录
    oplist(row) {
      console.log(row, "&&&&&&&&&&&&&&&&&&&&");
      _api
        .getUpdatedQuoteLog({
          merchantId: row.recycleMerchantId,
          orderNo: row.orderNo,
        })
        .then((res) => {
          console.log(res, "^^^^^^^^^^^^^^");
          this.getUpdatedQuoteLog = res.data.normal;
          this.remakeQuoteLog = res.data.remake;
          this.viewrecords = true;
        });
    },

    viewrecordsClose() {
      this.viewrecords = false;
    },
    // ClearSeachParams() {
    //   this.$store.dispatch("tagsView/ClearSeachParams", "");
    // },
    btnClick(type) {
      this.auditStatus = type;
      this.pages.currentPage = 1;
      this.handleCurrentChange();
    },
    // 导表
    submitExcel() {
      if (this.SeachParams.startTime || this.SeachParams.ackStartTime) {
        this.exportLoading = true;
        const params = {
          productId: this.SeachParams.productId,
          typeCode: this.SeachParams.typeCode,
          startTime: this.SeachParams.startTime,
          endTime: this.SeachParams.endTime,
          pageNum: this.pages.currentPage,
          pageSize: this.pages.pageSize,
          state: this.auditStatus,
          isFilterStock: this.isFilterStock,
          isFilterTime: this.isFilterTime,
        };
        _api
          .orderExcel(params)
          .then((res) => {
            console.log(res);
            const content = res;
            const blob = new Blob([content]);
            let reader = new FileReader(); // 创建读取文件对象
            reader.addEventListener("loadend", () => {
              //
              try {
                let data = JSON.parse(reader.result);
                if (data.code === 0) {
                  this.$message.error(data.msg || "导出失败");
                }
              } catch (err) {
                const fileName = "订单列表.xlsx";
                if ("download" in document.createElement("a")) {
                  // 非IE下载
                  const elink = document.createElement("a");
                  elink.download = fileName;
                  elink.style.display = "none";
                  elink.href = URL.createObjectURL(blob);
                  document.body.appendChild(elink);
                  elink.click();
                  URL.revokeObjectURL(elink.href); // 释放URL 对象
                  document.body.removeChild(elink);
                } else {
                  // IE10+下载
                  navigator.msSaveBlob(blob, fileName);
                }
              }
            });
            reader.readAsText(blob, "utf-8"); // 设置读取的数据以及返回的数据类型为utf-8
            this.exportLoading = false;
          })
          .catch((err) => {
            this.exportLoading = false;
          });
      } else {
        this.$message({
          message: "请先选择时间查询再导出",
          type: "error",
        });
      }
    },
    clickExcel() {
      this.excelVisible = true;
    },
    handleOperate(row, type) {
      this.currentRow = row;
      if (type == "edit") {
        this.edit = true;
        this.drawerDialogTitle = "修改商品信息";
        this.isEditGoods = true;
      } else if (type == "reUp") {
        this.isReup = true;
        this.drawerDialogTitle = "重新添加商品";
      } else {
        this.drawerDialogTitle = "商品信息";
        this.isEditGoods = true;
      }
      this.getProductDetail();
      this.cutindex = "01";
      this.drawerDialog = true;
    },
    // 商品详情
    getProductDetail() {
      _api
        .productDetail({ productId: this.currentRow.productId })
        .then((res) => {
          if (res.code === 1) {
            this.drawerInitData = res.data;
            this.drawerInitData.expireTime = [
              res.data.periodStart,
              res.data.periodEnd,
            ];
            this.protocolData.CUSTOMER_SERVICE_PROTOCOL =
              this.drawerInitData.productDesciption;
            this.tabletitleData = this.drawerInitData.sellingPointList || [];
          }
        });
    },
    // 跳转
    handleClick(row) {
      let routeData = this.$router.resolve({
        path: "/RecallOrder/Details",
        query: { type: "edit", id: row.orderNo },
      });
      window.open(routeData.href, "_blank");
    },
    handleCurrentChange(val) {
      this.loading = true;
      if (val) {
        this.pages.currentPage = val;
      }
      const vo = {
        productId: this.SeachParams.productId,
        typeCode: this.SeachParams.typeCode,
        startTime: this.SeachParams.startTime,
        endTime: this.SeachParams.endTime,
        pageNum: this.pages.currentPage,
        pageSize: this.pages.pageSize,
        state: this.auditStatus,
        isFilterStock: this.isFilterStock ? "00" : "",
        isFilterTime: this.isFilterTime ? "00" : "",
      };
      _api
        .renewProductList(vo)
        .then((res) => {
          console.log(1111, res);
          if (res.code === 1) {
            this.$emit("getUnPayUserOrders", res.data.unPayUserOrders);
            this.pages.total = res.data.list.total;
            this.applyNumber.overdue = res.data.overdue;
            this.applyNumber.sellOut = res.data.sellOut;
            this.applyNumber.selling = res.data.selling;
            this.applyNumber.unPutaway = res.data.unPutaway;
            this.itemTable = res.data.list.records;
            this.orderTableList = [];
            for (let i = 0; i < this.itemTable.length; i++) {
              this.itemArr = this.itemTable[i];
              this.orderTableList.push(
                this.handleData({
                  ...this.itemArr,
                  healthCode: getHealthCode(this.itemArr.healthCode),
                })
              ); // 数据重新组装重置为--
              if (i > 10) {
                return;
              }
            }
            this.loading = false;
          }
          if (typeof this.SeachParams.disuseLoding === "function") {
            this.SeachParams.disuseLoding();
          }
        })
        .catch(() => {
          if (typeof this.SeachParams.disuseLoding === "function") {
            this.SeachParams.disuseLoding();
          }
        });
    },
    /********* 5-18新增 ************/
    copy(e) {
      const spanText = document.getElementById(e).innerText;
      const oInput = document.createElement("input");
      oInput.value = spanText;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.className = "oInput";
      oInput.style.display = "none";
      document.body.removeChild(oInput);
      this.$message.success("复制成功");
    },
    openImgBox(row) {
      console.log(row);
      this.imgShow = true;
      // this.imgList = e
      this.DialogImgList = [
        [...(row.images == "--" || !row.images ? [] : row.images)],
        [...(row.reImages == "--" || !row.reImages ? [] : row.reImages)],
      ];
      console.log(this.DialogImgList);
    },
    chooseImages(e) {
      if (e == 0) {
        this.imgIndex = 0;
        this.imgShowOnly = true;
      }
      if (e == 1) {
        this.imgIndex = 1;
        this.imgShowOnly = false;
      }
    },
    getindex(e) {
      console.log(e);
      this.imgShowIndex = e;
    },
    imgClose() {
      console.log(1);
      this.imgShow = false;
      this.imgList = [];
    },
    // 跳转至换新订单
    goRenewOrder(row) {
      console.log(234, row);
      let routeData = this.$router.resolve({
        path: "/renewalActivity/renewOrder",
        query: { type: "edit", productId: row.productId },
      });
      window.open(routeData.href, "_blank");
    },
    // 报价商家弹窗
    openStoreList(e) {
      console.log(222, e);
      (this.productRecord = {
        productCode: e.productCode,
        productName: e.productName,
        subsidyPrice: e.subsidyPrice,
      }),
        // this.baoPricestate = e.state
        // this.merchantName = e.merchantName;

        _api.modifyRecord({ productId: e.productId }).then((res) => {
          console.log(res, "orderStoreList");
          if (res.code == 1) {
            this.storeList = res.data.records;
          }
        });
      this.storeShow = true;
    },
    storeClose() {
      this.storeShow = false;
      this.storeList = [];
    },
    // 数字转换
    convertYypeNumer(num) {
      let v = num;
      // 是否类型正确
      let isType = true;
      if (typeof v !== "number") {
        isType = false;
        v = Number(v);
        if (isNaN(v)) {
          v = 0;
        }
      }
      return {
        isType,
        v,
      };
    },

    // 计算金额值
    computedMoney(num1, num2, isAdd = true) {
      const v1 = this.convertYypeNumer(num1);
      let v2 = this.convertYypeNumer(num2);
      if (!v1.isType && !v2.isType) {
        return "--";
      }
      v1.v = Math.abs(v1.v);
      v2.v = Math.abs(v2.v);

      return isAdd ? v1.v + v2.v : v1.v - v2.v;
    },
    //获取明秀
    getMoneyDetail(orderNo, cb) {
      _api.getQuoteCompute(orderNo).then((r) => {
        let data = setValue(r.data);
        data = {
          ...data,
          // 回收商实收价
          netQuotePrice: this.computedMoney(
            data.quotePrice,
            data.depreciatePrice,
            false
          ),
          // 员工红包
          angPow: this.computedMoney(data.angPowSmStaff, data.angPowStaff),
          // 公司压价返利
          companyRebate: this.computedMoney(
            data.orderCutPrice,
            (data.allStaffCutPrice + data.cutPriceManagerReward),
            false
          ),
        };
        cb(data);
      });
    },
    // 查看明细
    moneyDetail(v) {
      this.getMoneyDetail(v.orderNo, (data) => {
        this.dealDetailProps = {
          ...this.dealDetailProps,
          show: true,
          // 待确认和已取消代表未确认，返回false，其他作为true
          type: ["00", "10"].indexOf(v.state) < 0,
          data,
        };
      });
    },
    // 所有不为真的第一层数据重置为--
    handleData(param) {
      for (const key in param) {
        if (Object.prototype.toString.call(param[key]) === "[object Object]") {
          this.handleData(param[key]);
        } else if (!param[key] || param[key] == undefined || param[key] == "") {
          param[key] = "--";
        }
      }
      return param;
    },
    DialoghandleBtn(row) {
      if (row.state === "10") {
        this.dialogTitle = "查看取消原因";
        this.dialogcancel.remark = row.cancelCause;
      } else {
        this.dialogTitle = "查看作废原因";
        this.dialogcancel.remark = row.abolishCause;
      }
      this.dialogVisibleOrder = true;
    },
    // //弹窗取消
    resetPopupData() {
      this.dialogVisibleOrder = false;
    },
    //弹窗确定
    submitPopupData() {
      this.dialogVisibleOrder = false;
    },
    // 撤销订单
    revokeOrder(row) {
      this.revokeShow = true;
      this.revokeParams.orderNo = row.orderNo;
    },
    // 撤销订单弹框关闭
    revokeClose() {
      this.revokeShow = false;
      this.revokeParams = {
        password: "",
        refundRemark: "",
      };
    },
    // 加价弹窗关闭按钮
    plusPriceClose() {
      this.pcaddPric = null;
      this.plusPriceIF = false;
    },
    // 撤销订单弹框确定
    revokeSure() {
      if (!this.revokeParams.refundRemark) {
        this.$message.error("请输入撤销原因");
        return;
      }
      if (!this.revokeParams.password) {
        this.$message.error("请输入登录密码");
        return;
      }
      this.btnLoading = true;
      _api
        .refundOrder(this.revokeParams)
        .then((res) => {
          if (res.code === 1) {
            this.$message.success("撤销成功");
            this.handleCurrentChange();
            this.revokeShow = false;
          }
          console.log(res);
          this.btnLoading = false;
        })
        .catch((err) => {
          this.btnLoading = false;
        });
    },
    // 从账号弹框
    seeSubInfo(row) {
      this.subInfo = {
        staffName: row.createStaffSubName,
        nickName: row.createStaffSubNickName,
        img: row.createStaffSubImg,
      };
      this.subInfoShow = true;
    },
    subInfoClose() {
      this.subInfo = {
        staffName: "",
        nickName: "",
        img: "",
      };
    },
    // 查看补拍记录
    openRemakeList(row) {
      this.remakeRecordsShow = true;
      this.remakeloading = true;
      _api.listRemakeByOrderNo({ orderNo: row.orderNo }).then((res) => {
        console.log(res.data, "补拍备注");
        this.remakeImgList = res.data;
        this.remakeloading = false;
      });
    },
    enquiryDetailsClose() {
      this.chxInfo = {};
    },
    viewDetails(row) {
      this.enquiryDetailsShow = true;
      _api.orderinfoRepeat({ orderNo: row.orderNo }).then((res) => {
        this.chxInfo = res.data;
      });
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.function_box {
  max-height: 700px;
  overflow: auto;
}
/deep/.w-e-text-container {
  height: 120px !important;
}
/deep/.w-e-menu {
  width: 25px !important;
  height: 25px !important;
}
.flex-box {
  display: flex;
  padding-left: 40px;
  width: 90%;
}
.top_setion {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding: 20px 0 10px 40px;
  span {
    cursor: pointer;
    margin-right: 20px;
  }
}

.OrderTable {
  .top_bar {
    background: white;
    display: flex;
    justify-content: space-between;

    .case {
      display: flex;
      align-items: center;
      justify-content: space-between;
      align-items: center;

      .case-title {
        display: flex;

        .case-title_icon {
          width: 20px;
          height: 20px;
        }

        .case-title_max {
          font-weight: bold;
          color: #333333;
          font-size: 18px;
          // width: 80px;
          height: 17px;
          line-height: 17px;
          margin-left: 5px;
          font-family: FZLanTingHei-B-GBK;
        }
      }
    }
  }

  .button_top {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .faultBtn {
    //width: 432px;
    height: 34px;
    background: #f9fbfd;
    border: 1px solid #c1d1ff;
    // box-shadow: 0px 4px 8px 0px rgba(196, 197, 198, 0.2);
    border-radius: 21px;
    display: flex;
    cursor: pointer;
    .active {
      text-align: center;
      color: white;
      padding: 0 20px;
      // width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 32px;
      height: 32px;
      background: #0981ff;
      border-radius: 20px;
    }
    .none {
      text-align: center;
      color: #333;
      padding: 0 20px;
      // width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 32px;
      height: 32px;
      border-radius: 20px;
    }
  }

  .isFilter {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .filterLeft {
      width: 400px;
    }
  }

  /deep/ .el-table th {
    padding: 3px 0 !important;
  }

  .orderPagina {
    float: right;
    margin: 50px;
  }

  .order_list {
    .line_top {
      background-color: white;
      width: 100%;
      height: 10px;
    }

    .table_title {
      display: flex;
      // height: 40px;
      padding: 10px 0;
      align-items: center;
      justify-content: space-between;
      background: #f2f2f2;
      border-radius: 6px 6px 0px 0px;

      .left {
        // flex: 1;
        display: flex;
        position: relative;
        // flex-direction: column;
        padding-left: 50px;
        align-items: center;

        // flex-wrap: wrap;
        // justify-content: space-between;
        .left-top {
          display: flex;
        }

        .left-top div {
          margin-right: 50px;
          display: flex;
          align-items: center;

          .first-text {
            display: inline-block;
            width: 32px;
            height: 22px;
            background: #ffaf29;
            border-radius: 3px 11px 11px 3px;
            color: white;
            line-height: 22px;
            position: absolute;
            text-align: center;
            top: 0;
            left: -5px;
            margin-right: 50px;
            margin-top: -2px;
          }

          > span {
            font-size: 14px;
            font-family: FZLanTingHei-DB-GBK;
            font-weight: 400;
            // color: #0981ff;
          }

          > input {
            border: none;
            background: none;
            color: #0981ff;
            padding: 0;
            width: 140px !important;
            font-size: 14px;
          }

          > .copy {
            min-width: 36px;
            height: 16px;
            display: inline-block;
            line-height: 16px;
            text-align: center;
            background: #0981ff;
            color: #fff;
            margin-left: 8px;
            border-radius: 4px;
            font-size: 12px;
            cursor: pointer;
          }
        }
      }

      .identification {
        display: flex;
        // flex-direction: column;
        align-items: center;
        // margin-top: 10px;

        // padding-left: 50px;
        > span {
          margin-right: 10px;
        }

        > span:first-child {
          margin-top: 0;
        }

        .rightTrue {
          min-width: max-content;
          padding: 2px 8px;
          font-size: 14px;
          border: 1px solid #ff687b;
          margin-right: 20px;
          border-radius: 5px;
          text-align: center;
          color: #ff687b;
        }

        .rightFalse2 {
          background-color: #ffaf29;
          min-width: max-content;
          padding: 2px 8px;
          font-size: 14px;
          // margin-right: 10px;
          border-radius: 5px;
          text-align: center;
          color: #fff;
        }
      }

      .right {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        padding-right: 20px;
        color: #fff;

        .rightMid {
          font-size: 14px;
          font-family: FZLanTingHeiS-R-GB;
          font-weight: 400;
          text-align: center;
          width: 70px;
          height: 22px;
          background: #21d8c2;
          border-radius: 11px 0px 0px 11px;
        }
      }
    }
  }

  .order-nice {
    min-width: max-content;
    display: inline-block;
    padding: 2px 8px;
    font-size: 14px;
    background-color: #81d3f8;
    margin: 0 auto;
    border-radius: 5px;
    color: #fff !important;
    text-align: center;
    // margin-right: 10px;
    // margin-left: 50px;
  }

  .solo2 {
    min-width: max-content;
    background: #7dc165;
    border-radius: 11px;
    font-size: 14px;
    font-family: FZLanTingHeiS-R-GB;
    font-weight: 400;
    color: #ffffff !important;
    text-align: center;
    padding: 3px 10px;
    margin-right: 10px;
  }

  .online-payment {
    min-width: max-content;
    display: inline-block;
    padding: 2px 8px;
    font-size: 14px;
    background-color: #f57474;
    // margin: 0 auto;
    border-radius: 5px;
    color: #fff !important;
    text-align: center;
    // margin-left: 50px;
  }
}

// 表格样式+
.position {
  width: max-content;
  display: block;
  padding: 0px 4px;
  font-size: 14px;
  background-color: rgba(102, 204, 153, 1);
  margin: 0 auto;
  border-radius: 5px;
  color: #fff;
  text-align: center;
}

.position2 {
  width: max-content;
  display: block;
  padding: 0px 4px;
  font-size: 14px;
  margin: 0 auto;
  border-radius: 5px;
  text-align: center;
}

.images-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.images-box > img {
  width: 70px;
  height: 70px;
  margin-bottom: 10px;
}

.images-box > span {
  color: #0981ff;
  cursor: pointer;
}

.color-green {
  color: rgba(102, 204, 153, 1);
}

.color-red {
  color: #ff687b;
}

.text-down {
  text-decoration: underline;
  color: #0981ff;
  cursor: pointer;
}

// 弹窗
.img-box {
  margin-bottom: 20px;
  .recordStyle {
    display: flex;
    justify-content: space-between;
    width: 600px;
    align-items: center;
    height: 50px;
    color: #333;
  }
  // 图片
  .imgs-num {
    text-align: center;
    margin: 5px 0;
    font-weight: bold;
  }

  .img-tips-box {
    display: flex;
    height: 30px;
    width: max-content;
    border: 1px solid #0981ff;

    .img-tips {
      width: 80px;
      text-align: center;
      line-height: 30px;
      box-sizing: border-box;
      cursor: pointer;
    }

    .img-tips-default {
      background: #fff;
      color: #0981ff;
    }

    .img-tips-choose {
      background: #0981ff;
      color: #fff;
    }
  }

  // 列表
}

.isdeal {
  background: #ff687b;
  margin-right: 5px;
  display: inline-block;
}

.sec_img {
  width: 20vw;
  height: 80vh;
  margin: auto;

  img {
    width: 20vw;
    height: 80vh;
    object-fit: contain;
  }
}

.command {
  display: flex;
  align-items: center;
}

.command .el-input {
  width: 80%;
}

.onlyul {
  li {
    margin-top: 10px;
  }

  .firstli {
    margin: 0;
    color: #3a9aff;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .firstli_span {
      color: #ccc;
    }
  }

  .secondli {
    color: #ff6600;
    // font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.overflow-hiding {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.quoteNotecss {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box; //作为弹性伸缩盒子模型显示。
  -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
  -webkit-line-clamp: 2; //显示的行
}

.flex {
  display: flex;
  align-items: center;
}

.add-price-title {
  font-weight: bold;
  color: #333333;
  font-size: 16px;
  line-height: 20px;
  padding-left: 10px;
  border-left: 3px solid #0981ff;
  margin-bottom: 10px;
  color: #0981ff;
}

.add-price-conent {
  padding: 0 40px;
}

.deal_detail_title {
  width: 100%;
  padding-left: 16px;
  font-size: 14px;
  font-weight: 900;
  color: #000;
  position: relative;
  margin-bottom: 10px;

  &::after {
    content: "";
    width: 8px;
    height: 8px;
    background: #0c82ff;
    position: absolute;
    left: 0%;
    top: 50%;
    transform: translateY(-50%);
  }
}

.deal_detail_inner {
  margin-bottom: 20px;
  background: #f2f2f2;
  font-size: 12px;
  color: #111;
  padding: 16px;
  box-sizing: border-box;
  border-radius: 6px;
}

.deal_detail_line {
  margin-bottom: 16px;
}

.deal_detail_line-title {
  padding-left: 10px;
  position: relative;
  margin-bottom: 6px;
  font-weight: 600;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    width: 5px;
    height: 5px;
    background: #000;
    border-radius: 50%;
    transform: translateY(-50%);
  }
}

.deal_detail_line-tips {
  transform: translateX(-5px);
}

.deal_detail_line-tips-blue {
  color: #0981fe;
}

.deal_detail_line-tips-red {
  color: #ff0000;
}

.test-function {
  margin-top: 20px;
}
.step {
  .step-title {
    display: flex;
    color: #ff687b;
    margin-bottom: 18px;
  }

  .fileName {
    /deep/.el-input {
      width: 260px;
    }

    /deep/.el-button {
      // border-radius: 10px;
      margin-right: 0px;
    }
  }

  .step-content {
    margin-bottom: 20px;
  }
}
.artificial-test-info {
  width: 100%;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #646464;
  margin-bottom: 10px;
}

.system-result-title {
  color: #646464;
  font-size: 16px;
  margin-bottom: 10px;
}

.fs16 {
  font-size: 16px;
  margin-bottom: 10px;
}

.mb10 {
  margin-bottom: 10px;
}

.el_from {
  margin-left: 30px;
}

.footer {
  display: flex;
  justify-content: end;
  margin-right: 120px;
  margin-top: 20px;
}

.el-form-item {
  margin-bottom: 12px;
}

/deep/.el-dialog {
  .el-dialog__body {
    padding: 0 20px 0 20px;
  }
}
/deep/.el-drawer__header {
  margin-bottom: 0;
}
/deep/.el-date-editor.el-input__inner {
  width: 80% !important;
}
.temsGift {
  /deep/.el-radio {
    display: block;
    margin-top: 15px;
  }
}
/deep/.el-drawer__body {
  overflow: auto;
}
.icon_content {
  padding-left: 40px;
}
.section_time {
  display: flex;
  align-items: center;
  margin-bottom: 18px;

  span {
    color: #ff687b;
    margin-right: 4px;
    margin-left: 5px;
  }

  p {
    font-size: 14px;
    color: #666666;
    padding-right: 16px;
  }

  width: 80%;
}
.Encourag_picture {
  margin: 15px 0;
  display: flex;
  flex-wrap: wrap;

  img {
    width: 100px;
    height: 100px;
    border-radius: 4px;
    margin-right: 10px;
  }
}

.ep_image {
  position: relative;

  .imgredion {
    position: absolute;
    top: 0;
    right: 0;
    width: 15px;
    height: 15px;
  }
}
.seaShili{
  margin-right: 20px;
  position: absolute;
    right: 0;
    top: 5px;
}
</style>
